// components/ContentSection.jsx
import React from 'react';

const ContentSection = ({
    title,
    subtitle,
    description,
    buttonText,
    buttonLink,
    imageUrl,
    imageAlt,
    items = [],
    backgroundColor = "#ffffff",
    textColor = "#0B253F",
    accentColor = "#144443",
    reverseLayout = false
}) => {

    const itemGroups = () => {
        const mid = Math.ceil(items.length / 2);
        return [items.slice(0, mid), items.slice(mid)];
    };

    // const groups = itemGroups();

    return (
        <div
            className="elementor-element elementor-element-15384c4 e-con-full qodef-elementor-content-grid e-flex e-con e-parent e-lazyloaded"
            data-id="15384c4"
            data-element_type="container"
            style={{ "--padding-top": "50px", "--padding-bottom": "85px" }}
        >
            <div
                className="elementor-element elementor-element-66d4fbd e-con-full e-flex e-con e-child"
                data-id="66d4fbd"
                data-element_type="container"
                data-aos="fade-right"
                data-aos-offset="200" data-aos-delay="50" data-aos-duration="600"
                style={{ paddingTop: "70px" }}

            >
                <div
                    className="elementor-element elementor-element-fa33380 elementor-widget elementor-widget-startpro_core_section_title"
                    data-id="fa33380"
                    data-element_type="widget"
                    data-widget_type="startpro_core_section_title.default"
                >
                    <div className="elementor-widget-container" >
                        <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                            <h2 className="qodef-m-title" data-aos="fade-right"
                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900"
                            >
                              {title}
                                {" "}
                            </h2>
                            <p style={{ marginBottom: 10, fontSize: "18px" }} data-aos="fade-right"
                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900"
                            >    {subtitle}</p>
                            <span className="qodef-m-description" style={{ marginTop: 0, fontSize: "14px" }} data-aos="fade-right"
                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900">
                             {description}
                            </span>
                        </div>
                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-57280fa e-con-full e-flex e-con e-child"
                    data-id="57280fa"
                    data-element_type="container"

                >
                    <div
                        className="elementor-element elementor-element-0dfdeba e-con-full e-flex e-con e-child"
                        data-id="0dfdeba"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-3592f6d elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="3592f6d"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"

                        >
                            <div className="elementor-widget-container" >
                                <div className="qodef-icon-list-item qodef-icon--icon-pack  hover-icon-bounce">
                                    <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                        <span className="qodef-e-title-inner">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: "0px 13px 0px 0px",
                                                    width: 26,
                                                    height: 26,
                                                    lineHeight: 26,
                                                    backgroundColor: "#1e497d45"
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                    style={{ color: "#144443" }}
                                                />{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "13px" }}>{items[0]}
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-ddbfa9c elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="ddbfa9c"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-icon-list-item qodef-icon--icon-pack  hover-icon-bounce">
                                    <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                        <span className="qodef-e-title-inner">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: "0px 13px 0px 0px",
                                                    width: 26,
                                                    height: 26,
                                                    lineHeight: 26,
                                                    backgroundColor: "#1e497d45"
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                    style={{ color: "#144443" }}
                                                />{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "13px" }}>{items[1]}
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div
                                className="elementor-element elementor-element-ed2a040 elementor-widget elementor-widget-startpro_core_icon_list_item"
                                data-id="ed2a040"
                                data-element_type="widget"
                                data-widget_type="startpro_core_icon_list_item.default"
                            >
                                <div className="elementor-widget-container">
                                    <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                        <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                            <span className="qodef-e-title-inner">
                                                <span
                                                    className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                    style={{
                                                        margin: "0px 13px 0px 0px",
                                                        width: 26,
                                                        height: 26,
                                                        lineHeight: 26,
                                                        backgroundColor: "#DDE9E8"
                                                    }}
                                                >
                                                    {" "}
                                                    <span
                                                        className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                        style={{ color: "#144443" }}
                                                    />{" "}
                                                </span>{" "}
                                                <span className="qodef-e-title-text" style={{ fontSize: "14px" }}>Consulting for Large-Scale Hospitality & Commercial Projects
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div> */}
                    </div>
                    <div
                        className="elementor-element elementor-element-77ef1e8 e-con-full e-flex e-con e-child"
                        data-id="77ef1e8"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-fa914ec elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="fa914ec"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-icon-list-item qodef-icon--icon-pack  hover-icon-bounce">
                                    <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                        <span className="qodef-e-title-inner">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: "0px 13px 0px 0px",
                                                    width: 26,
                                                    height: 26,
                                                    lineHeight: 26,
                                                    backgroundColor: "#1e497d45"
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                    style={{ color: "#144443" }}
                                                />{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "13px" }}>{items[2]}
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-ed2a040 elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="ed2a040"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-icon-list-item qodef-icon--icon-pack  hover-icon-bounce">
                                    <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                        <span className="qodef-e-title-inner">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: "0px 13px 0px 0px",
                                                    width: 26,
                                                    height: 26,
                                                    lineHeight: 26,
                                                    backgroundColor: "#1e497d45"
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                    style={{ color: "#144443" }}
                                                />{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "13px" }}>{items[3]}
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div
                                                        className="elementor-element elementor-element-fa233ee elementor-widget elementor-widget-startpro_core_icon_list_item"
                                                        data-id="fa233ee"
                                                        data-element_type="widget"
                                                        data-widget_type="startpro_core_icon_list_item.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                                                <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                                                    <span className="qodef-e-title-inner">
                                                                        <span
                                                                            className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                                            style={{
                                                                                margin: "0px 13px 0px 0px",
                                                                                width: 26,
                                                                                height: 26,
                                                                                lineHeight: 26,
                                                                                backgroundColor: "#DDE9E8"
                                                                            }}
                                                                        >
                                                                            {" "}
                                                                            <span
                                                                                className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                                                style={{ color: "#144443" }}
                                                                            />{" "}
                                                                        </span>{" "}
                                                                        <span className="qodef-e-title-text">Smart Wallet</span>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="elementor-element elementor-element-73fc34e elementor-widget elementor-widget-startpro_core_icon_list_item"
                                                        data-id="73fc34e"
                                                        data-element_type="widget"
                                                        data-widget_type="startpro_core_icon_list_item.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                                                <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                                                    <span className="qodef-e-title-inner">
                                                                        <span
                                                                            className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                                            style={{
                                                                                margin: "0px 13px 0px 0px",
                                                                                width: 26,
                                                                                height: 26,
                                                                                lineHeight: 26,
                                                                                backgroundColor: "#DDE9E8"
                                                                            }}
                                                                        >
                                                                            {" "}
                                                                            <span
                                                                                className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                                                style={{ color: "#144443" }}
                                                                            />{" "}
                                                                        </span>{" "}
                                                                        <span className="qodef-e-title-text">Profit Planner</span>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div> */}
                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-7cc4ab3 elementor-widget elementor-widget-startpro_core_button"
                    data-id="7cc4ab3"
                    data-element_type="widget"
                    data-widget_type="startpro_core_button.default"
                >
                    <div className="elementor-widget-container">
                        <a
                            className="qodef-shortcode qodef-m  qodef-button qodef-layout--filled  qodef-html--link "
                            href="/contact_us"
                            target="_self"
                        >
                            <span className="qodef-m-text">Free consultation</span>
                        </a>
                    </div>
                </div>
            </div>
            <div
                className="elementor-element elementor-element-9ab111d e-con-full e-flex e-con e-child"
                data-id="9ab111d"
                data-element_type="container"
            >
                <div
                    className="elementor-element elementor-element-5cfc504 elementor-widget elementor-widget-slider_revolution"
                    data-id="5cfc504"
                    data-element_type="widget"
                    data-widget_type="slider_revolution.default"
                >
                    <div className="elementor-widget-container sr7t">
                        <div className="wp-block-themepunch-revslider">
                            <sr7-module
                                data-alias="consulting"
                                data-id={4}
                                id="SR7_4_1"
                                data-version="6.7.25"
                                style={{ height: 570 }}
                                data-current={7}
                            >
                                <sr7-adjuster style={{ height: 570 }} />
                                <sr7-content style={{ height: 570, left: 0, width: 650, top: 0 }}>
                                    <sr7-slide
                                        id="SR7_4_1-7"
                                        data-key={7}
                                        style={{
                                            pointerEvents: "auto",
                                            visibility: "visible",
                                            display: "block",
                                            zIndex: 5
                                        }}
                                    >
                                        <sr7-mask
                                            style={{
                                                overflow: "visible",
                                                minHeight: "auto",
                                                minWidth: "auto",
                                                width: "100%",
                                                height: 570,
                                                zIndex: 0,
                                                // position: "absolute",
                                                display: "block",
                                                visibility: "visible",
                                                left: 0,
                                                top: 0
                                            }}
                                        >
                                            <sr7-bg
                                                id="SR7_4_1-7-4"
                                                className="sr7-layer"
                                                data-type="shape"
                                                data-subtype="slidebg"
                                                style={{
                                                    padding: 0,
                                                    width: "100%",
                                                    height: 570,
                                                    display: "block",
                                                    visibility: "inherit",
                                                    pointerEvents: "none",
                                                    opacity: 1
                                                }}
                                            >
                                                <canvas
                                                    width={650}
                                                    height={570}
                                                    style={{
                                                        width: 650,
                                                        height: 570,
                                                        visibility: "visible",
                                                        background: "transparent",
                                                        opacity: 1
                                                    }}
                                                />
                                            </sr7-bg>
                                        </sr7-mask>
                                        <sr7-img
                                            id="SR7_4_1-7-0"
                                            className="sr7-layer"
                                            style={{
                                                overflow: "visible",
                                                padding: 0,
                                                width: 414,
                                                height: 414,
                                                zIndex: 6,
                                                position: "absolute",
                                                transformOrigin: "50% 50%",
                                                transform: "translate(0px, 0px)",
                                                display: "block",
                                                background: `url(${imageUrl}) 50% 50% / cover no-repeat transparent`,
                                                    // 'url("/img/666917.jpg") 50% 50% / cover no-repeat transparent',
                                                left: 118,
                                                top: 78,
                                                visibility: "visible",
                                                opacity: 1,
                                                pointerEvents: "auto"
                                            }}
                                        />

                                    </sr7-slide>
                                    <sr7-slide
                                        id="SR7_4_1-8"
                                        data-key={8}
                                        className="sr7-staticslide sr7-staticslide-high"
                                        style={{
                                            pointerEvents: "none",
                                            display: "block",
                                            visibility: "visible"
                                        }}
                                    ></sr7-slide>
                                    <sr7-module-shadow className="sr7-shdw-0" />
                                </sr7-content>
                            </sr7-module>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentSection;